module.exports = __webpack_public_path__ + "media/images/costumes/top/swiper-dress-4-6389996c326744bfc5a523eda7890bcd.jpg";